  
const Golf_Tips = () => {
  return (
    <div class="mainContent">
      <h1>Tips for Ready Golf</h1>
      <ul class="gamesList" style={{ marginBottom: "70px" }}>
            <li>
              <h2 style={{ textAlign: "center" }}>General</h2>
                <ul>
                    <li>Always play to keep up with the group in front of you… not to just stay ahead of the group behind you.</li>
                    <li>While other players in your group are hitting their shots, line your shot up and be ready to hit your shot when it’s your turn.</li>
                    <li>Watch your shot to completion and line it up with something in the distance (tree, rock,water feature, etc.) so you have a reference point when you are looking for your ball.</li>
                    <li>Positioning yourself for Ready Golf <ul>
                            <li>Don’t get too far ahead of your playing partners. You want to be moving toward your ball as much as possible and as quickly as possible but getting too far in front of your fellow golfers can be rude and dangerous.</li>
                            <li>Keep the line of play clear. You can move ahead of the other players, but never
stand between their ball and the hole along the line of play. Instead, move
forward along the side of the fairway away from others.</li>
                        </ul></li>
                </ul>
                
            </li>
            <li>
              <h3 style={{ marginTop: "45px" }}>On the Tee</h3>
                <ul>
                    <li>Pay attention to everyone’s tee shot so you can help look for lost balls.</li>
                    <li>Ready Golf on the tee… first one ready to hit should do so regardless of Honors (unless someone birdies the previous hole… never step in front of birdie unless you are ready to accept the PBFU).</li>
                    <li>If you are waiting for the group in front of you to clear the fairway, let the shorter hitters tee off first once the group is clear.</li>
                    <li>If there are players that are teeing off from different tee locations (i.e. regular and forward), the players that will be teeing off from the forward tees should have their driver out while at the regular tees so they are ready to go once they arrive at the forward tees.</li>
                </ul>
            </li>
            <li>
              <h3 style={{ marginTop: "45px" }}>On the Green</h3>
                <ul>
                    <li>When you approach the green, start looking at green for contours so that you are reading your putt while you approach the green.</li>
                    <li>Study your putt while waiting your turn to putt.</li>
                    <li>The first golfer to the hole should take out the flagstick (assuming the players want it out).</li>
                    <li>The first player to hole out their putt should pick up the flag stick and be ready to return it to the hole once everyone else has putted.</li>
                    <li>If you take multiple clubs to the green (i.e. putter and chipping iron), make sure to put your extra club(s) near the flagstick on the ground or near your exit point from the green to minimize possibility of leaving clubs.</li>
                </ul>
            </li>
            <li>
              <h3 style={{ marginTop: "45px" }}>Lost Balls</h3>
                <ul>
                    <li>Three (3) minute limit once you arrive to the area and starting looking for your ball.</li>
                    <li>If someone in your group has lost ball their ball, hit your shot before helping them look for their ball.</li>
                </ul>
            </li>
            <li>
              <h3 style={{ marginTop: "45px" }}>Cart Strategies</h3>
                <ul>
                    <li>After finishing a hole, exit the green and go straight to your cart.</li>
                    <li>Wait to record scores until you reach the next tee, not when you leave the green. This allows the group behind you to hit up to the green.</li>
                    <li>Make sure to leave the cart at the proper exit point from the green to proceed directly to the next tee.</li>
                </ul>
            </li>
            <li>
              <h3 style={{ marginTop: "45px" }}>Completion of Round</h3>
                <ul>
                    <li>Shake hands with your playing partners and quickly exit the green.</li>
                    <li>Wait until you get back to the clubhouse to record your last holes scores and put all your golf items back in your bag (i.e. Rangefinder, tees, ball markers, balls, etc.). Don’t delay the group behind you while putting things away.</li>
                </ul>
            </li>
      </ul>
    </div>
  );
};
  
export default Golf_Tips;